import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatCep'
})
export class FormatCepPipe implements PipeTransform {

  transform(value: string | undefined): string {
    if (!value) return '';

    const onlyNumbers = value.replace(/\D/g, '');

    if (onlyNumbers.length === 8) {
      return onlyNumbers.replace(/(\d{5})(\d{3})/, '$1-$2');
    }

    return value;
  }
}
